<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 10:33:33
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-02-01 14:48:24
-->
<template>
  <div class="paper-design">
    <div class="question-wrapper">
      <div class="title">
        <span class="text">试题列表（{{ storename }}）</span>
        <el-dropdown placement="bottom-start" @command="handleAddQuestion">
          <span class="el-dropdown-link">
            <i class="el-icon-plus"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="typeDropdown">
            <el-dropdown-item v-for="(item, index) in typeMap" :key="index" :command="index">{{
              item.name
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="search-bar">
        <el-input
          v-model="questionName"
          placeholder="请输入题目名称"
          size="small"
          clearable
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
      </div>
      <div class="question-list">
        <draggable
          v-model="questionList"
          class="drag"
          chosen-class="chosen"
          animation="300"
          :disabled="loading"
          filter=".forbid"
          :move="onMove"
          @end="onDragEnd"
        >
          <transition-group>
            <div
              v-for="(item, index) in questionList"
              :key="item.id"
              :class="[
                'question-item',
                { active: item.id == activeQustion.id },
                { forbid: !item.questionId },
              ]"
            >
              <div class="itemBox">
                <div class="itemInfo" @click="selectQuestion(item)">
                  <div class="index">{{ index + 1 + (pager.current - 1) * 10 }}</div>
                  <div
                    class="type"
                    :style="
                      `color:${typeMap[item.questionType].color};background-color:${
                        typeMap[item.questionType].bgColor
                      }`
                    "
                  >
                    {{ typeMap[item.questionType].name }}
                  </div>
                  <div class="name">{{ replaceHtml(item.questionName || '') }}</div>
                  <div class="score">({{ item.score }}分)</div>
                </div>
                <div class="itemScore" @click="handleDeleteQuestion(item)">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </div>
          </transition-group>
        </draggable>
      </div>
      <div class="question-pagination">
        <el-pagination
          small
          background
          layout="prev, pager, next"
          :current-page.sync="pager.current"
          :page-size="pager.size"
          :total="pager.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="design-wrapper">
      <div class="title">编辑试题</div>
      <div class="design">
        <el-empty v-if="!activeQustion.id" description="未选择试题"></el-empty>
        <template v-if="activeQustion.id">
          <div class="header">
            <div class="index">
              <span>【{{ typeMap[activeQustion.questionType].name }}】</span>第{{
                activeQustion.questionSort
              }}题
            </div>
            <div class="score">
              本题分值<el-input-number
                v-model.number="questionInfo.score"
                :controls="false"
                :min="0"
              ></el-input-number
              >分
            </div>
          </div>
          <Single
            v-show="activeQustion.questionType == 1"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Multiple
            v-show="activeQustion.questionType == 2 || activeQustion.questionType == 10"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Judge
            v-show="activeQustion.questionType == 4"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Completion
            v-show="activeQustion.questionType == 5"
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
          <Subjective
            v-show="
              (activeQustion.questionType == 3 || activeQustion.questionType > 5) &&
                activeQustion.questionType !== 10
            "
            :question-info="questionInfo"
            :loading="saveLoading"
            @edit="onEdit"
            @remove="onRemove"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import Judge from './components/Judge'
import Single from './components/Single'
import Completion from './components/Completion'
import Multiple from './components/Multiple'
import Subjective from './components/Subjective'
import {
  questionStoreList,
  questionListSort,
  questionDetail,
  questionCreate,
  questionEdit,
  questionRemove,
} from '@/api/exam'
import to from 'await-to'
import { mapGetters } from 'vuex'
export default {
  name: 'PaperDesign',
  components: {
    draggable,
    Judge,
    Single,
    Completion,
    Multiple,
    Subjective,
  },
  data() {
    return {
      loading: false,
      activeQustion: {},
      score: 1,
      typeMap: {
        1: { name: '单选题', color: '#3671BF', bgColor: '#EBF2FA' },
        2: { name: '多选题', color: '#36BFA8', bgColor: '#EBFAF8' },
        3: { name: '计算题', color: '#B4872E', bgColor: '#FAF4E9' },
        4: { name: '判断题', color: '#2EBE46', bgColor: '#EBFAED' },
        5: { name: '填空题', color: '#9DB236', bgColor: '#F7FAE9' },
        6: { name: '简答题', color: '#BF4D36', bgColor: '#FAEBE9' },
        7: { name: '论述题', color: '#BF367B', bgColor: '#FAEEF3' },
        8: { name: '案例分析题', color: '#4D36BF', bgColor: '#EEEBFA' },
        9: { name: '综合题', color: '#A836BF', bgColor: '#F8EBFA' },
      },
      questionList: [],
      questionName: '',
      questionInfo: {
        optionList: [],
      },
      saveLoading: false,
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      pageSize: 0,
      storename: this.$route.query.name || '',
    }
  },
  computed: {
    ...mapGetters(['userId']),
  },
  async mounted() {
    await this.getQuestionList()
    if (this.questionList.length) this.selectQuestion(this.questionList[0])
  },
  methods: {
    handleCurrentChange(current) {
      this.pager.current = current
      this.getQuestionList()
    },
    handleSearch() {
      this.pager.current = 1
      this.getQuestionList(1)
    },
    selectQuestion(item) {
      this.activeQustion = item
      this.getQuestionInfo(this.activeQustion.id)
    },
    async getQuestionList(current = '') {
      const { size } = this.pager
      this.loading = true
      const [res, err] = await to(
        questionStoreList({
          current: current || this.pager.current,
          size,
          storeId: this.$route.query.id,
          questionName: this.questionName,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.loading = false
      this.questionList = res.data.list
      this.pager.total = res.data.total
      this.pager.current = res.data.current
      this.pageSize = res.data.current
    },
    async handleAddQuestion(command) {
      const [res, err] = await to(
        questionCreate({
          storeId: this.$route.query.id,
          questionType: command,
          userId: this.userId,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$nextTick(async () => {
        let sort = res.data.sort
        let current = Math.ceil(sort / 10)
        await this.getQuestionList(current)
        this.selectQuestion(
          this.questionList.filter(item => item.id == res.data.storeQuestionId)[0] || {},
        )
      })
    },
    async sortQuestionList() {
      let indexList = this.questionList.map((item, index) => {
        if (typeof item.questionId == 'number') {
          return {
            id: item.questionId,
            index: (this.pager.current - 1) * 10 + index + 1,
          }
        }
      })
      indexList = indexList.filter(item => item)
      const [, err] = await to(questionListSort({ indexList }))
      if (err) return this.$message.warning(err.msg)
      let id = this.activeQustion.id
      await this.getQuestionList()
      let arry = this.questionList.filter(item => item.id == id)
      if (arry.length > 0) {
        this.activeQustion = this.questionList.filter(item => item.id == id)[0] || {}
      }
    },
    onMove(e) {
      return !!e.relatedContext.element.questionId
    },
    onDragEnd() {
      this.sortQuestionList()
    },
    async getQuestionInfo(id) {
      const [res, err] = await to(questionDetail({ id }))
      if (err) return this.$message.warning(err.msg)
      this.questionInfo = res.data
      this.questionInfo.analysis = res.data.analysis || ''
      if (this.questionInfo.optionList.length) {
        for (let i = 0; i < this.questionInfo.optionList.length; i++) {
          const option = this.questionInfo.optionList[i]
          if (option.rightKey) {
            if (this.questionInfo.questionType == 2 || this.questionInfo.questionType == 10) {
              if (!this.questionInfo.rightOptionId)
                this.$set(this.questionInfo, 'rightOptionId', [])
              this.questionInfo.rightOptionId.push(option.id)
            } else {
              this.$set(this.questionInfo, 'rightOptionId', option.id)
            }
          }
        }
      } else {
        let optionList = []
        if (this.activeQustion.questionType == 4) {
          // 判断题
          optionList = [
            {
              id: 'new0',
              optionName: '对',
            },
            {
              id: 'new1',
              optionName: '错',
            },
          ]
        } else {
          optionList = [
            {
              id: 'new0',
              optionName: '',
            },
          ]
        }
        this.questionInfo = {
          ...this.questionInfo,
          score: 0,
          questionType: this.activeQustion.questionType,
          rightOptionId:
            this.activeQustion.questionType == 2 || this.activeQustion.questionType == 10
              ? ['new0']
              : 'new0',
          optionList,
        }
      }
    },
    async editQuestionInfo(param) {
      this.saveLoading = true
      const [, err] = await to(questionEdit({ param }))
      setTimeout(() => {
        this.saveLoading = false
      }, 500)
      if (err) return this.$message.warning(err.msg)
      this.$message.success('编辑成功')
      this.getQuestionList()
    },
    handleDeleteQuestion(item) {
      this.$confirm(`您确定要删除试题吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            questionRemove({
              questionId: item.questionId,
              questionStoreId: this.$route.query.id,
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          await this.getQuestionList()
          let pageSize = Math.ceil(this.pager.total / 10)
          if (pageSize < this.pageSize) {
            this.$nextTick(async () => {
              await this.getQuestionList(pageSize)
            })
          }
          if (item.id == this.activeQustion.id) {
            this.activeQustion = {}
          } else {
            this.questionList.forEach(element => {
              if (this.activeQustion.id == element.id) {
                this.activeQustion = element
              }
            })
          }
        })
        .catch(() => {})
    },
    deleteQuestion(question) {
      this.$confirm(`您确定要删除试题吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            questionRemove({
              questionId: question.questionId,
              questionStoreId: this.$route.query.id,
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          await this.getQuestionList()
          let pageSize = Math.ceil(this.pager.total / 10)
          if (pageSize < this.pageSize) {
            this.$nextTick(async () => {
              await this.getQuestionList(pageSize)
            })
          }
          this.activeQustion = {}
        })
        .catch(() => {})
    },
    async onEdit(params) {
      this.editQuestionInfo(
        this.htmlEncode(JSON.stringify({ ...params, id: this.activeQustion.id })),
      )
    },
    htmlEncode(str) {
      var s = ''
      if (str.length == 0) return ''
      s = str.replace(/&/g, '&amp;')
      s = s.replace(/</g, '&lt;')
      s = s.replace(/>/g, '&gt;')
      s = s.replace(/'/g, '&apos;')
      s = s.replace(/"/g, '&quot;')
      return s
    },
    onRemove() {
      if (this.activeQustion.id.toString().indexOf('new') != -1) {
        this.questionList.map((item, index) => {
          if (item.id == this.activeQustion.id) {
            this.activeQustion = {}
            return this.questionList.splice(index, 1)
          }
        })
      } else {
        this.deleteQuestion(this.activeQustion)
      }
    },
    replaceHtml(str) {
      return str.replace(/<[^>]+>/g, '')
    },
  },
}
</script>
<style lang="scss" scoped>
.typeDropdown {
  width: 130px;
  .el-dropdown-menu__item {
    height: 36px;
    padding-left: 30px;
  }
}
.paper-design {
  height: 100vh;
  box-sizing: border-box;
  padding-bottom: 20px;
  overflow: hidden;
  display: flex;
  .question-wrapper {
    height: 100%;
    background-color: #fff;
    width: 380px;
    margin-right: 20px;
    .title {
      height: 50px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 500;
      color: #434b51;
      line-height: 50px;
      border-bottom: 1px solid #eceef2;
      box-sizing: border-box;
      .text {
        @extend %one-line-text;
        flex: 1;
        min-width: 0;
        padding-right: 10px;
      }
      i {
        font-size: 16px;
        cursor: pointer;
        color: #3671bf;
      }
    }
    .search-bar {
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      align-items: center;
      .el-input {
        flex: 1;
        margin-right: 10px;
      }
      .el-button {
        width: 90px;
        height: 32px;
        padding: 0 10px;
        box-sizing: border-box;
      }
    }
    .question-list {
      box-sizing: border-box;
      padding: 10px;
      overflow: auto;
      height: calc(100% - 152px);
    }
    .question-pagination {
      height: 50px;
      padding: 0 20px;
      display: flex;
      justify-content: center;
    }
    .question-item {
      box-sizing: border-box;
      padding: 10px;
      // cursor: move;
      display: flex;
      align-items: center;
      border-radius: 4px;
      &.active {
        .index {
          background: #3671bf;
          color: #fff;
          border-color: #3671bf;
        }
        .name {
          color: #3671bf;
        }
      }
      .itemBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .itemInfo {
          display: flex;
          flex-shrink: 0;
          cursor: move;
          .score {
            flex: 1;
            font-size: 14px;
            font-weight: 400;
          }
        }
        .itemScore {
          display: flex;
          flex-shrink: 0;
          margin-left: 5px;
          cursor: pointer;
          .el-icon-delete {
            padding-top: 4px;
            font-size: 14px;
          }
        }
      }
      .index {
        width: 36px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #e6e8ed;
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        text-align: center;
        box-sizing: border-box;
        line-height: 22px;
        margin-right: 10px;
      }
      .type {
        padding: 5px 4px;
        white-space: nowrap;
        font-size: 14px;
        line-height: 14px;
      }
      .name {
        flex: 1;
        font-size: 14px;
        font-weight: 400;
        color: #4d4d4d;
        @extend %one-line-text;
        padding-left: 4px;
        max-width: 140px;
        min-width: 140px;
      }
    }
    .chosen {
      box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px #0000000d, 0 12px 48px 16px #00000008;
    }
  }
  .design-wrapper {
    overflow: hidden;
    position: relative;
    flex: 1;
    background-color: #fff;
    padding-bottom: 20px;
    .title {
      height: 50px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 500;
      color: #434b51;
      line-height: 50px;
      border-bottom: 1px solid #eceef2;
      box-sizing: border-box;
    }
    .design {
      box-sizing: border-box;
      height: calc(100% - 90px);
      padding: 20px;
      overflow: auto;
      .header {
        box-sizing: border-box;
        width: 883px;
        height: 52px;
        background: #f5f7fa;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        padding: 0 20px 0 10px;
        span {
          color: #3671bf;
        }
        /deep/ .el-input-number {
          width: 60px;
          margin: 0 4px;
          .el-input {
            width: 60px;
            border-radius: 2px;
            input {
              box-sizing: border-box;
              height: 32px;
              padding: 0 4px;
            }
          }
        }
      }
      /deep/.footer {
        z-index: 99;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        background: #ffffff;
        box-shadow: 0px -2px 10px 1px #e7ebf2;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button {
          width: 100px;
          height: 40px;
          border-radius: 4px;
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
